export default __webpack_public_path__ + "static/media/Q22023.d3e8e4eb.pdf";